export const USER_UPDATE_USER = 'USER_UPDATE_USER';
export const USER_OFFICES = 'USER_OFFICES';
export const USER_ACTIVE_OFFICE = 'USER_ACTIVE_OFFICE';

export const LOOKUP_OFFICES = 'LOOKUP_OFFICES';
export const LOOKUP_DEPARTMENTS = 'LOOKUP_DEPARTMENTS';
export const LOOKUP_US_STATES = 'LOOKUP_US_STATES';
export const LOOKUP_EB_ENROLLMENT_TYPES = 'LOOKUP_EB_ENROLLMENT_TYPES';
export const LOOKUP_REFERRAL_STATES = 'LOOKUP_REFERRAL_STATES';
